import { WorkspaceWindowTypeEnum, WorkspaceWindowTypeEnumType } from '@mark43/cad-api';
import { ActionBroadcaster } from '@m43/action-broadcaster';
import { CadNextAction } from './types';
import { electronBridge } from '../electron-bridge/electron-bridge';
import { logErrorMessage, logWarn } from '../monitoring/log';

export function initializeActionBroadcasterElectronBindings(
    workspaceWindowType: WorkspaceWindowTypeEnumType
): void {
    const isValidWindowType = (
        windowType: string
    ): windowType is CadNextAction['targetWindowType'] => {
        return (
            windowType === 'ROOT' ||
            !!WorkspaceWindowTypeEnum[windowType as WorkspaceWindowTypeEnumType]?.isCadNext
        );
    };

    if (electronBridge && 'actionBroadcasterInterface' in electronBridge) {
        electronBridge.actionBroadcasterInterface.handleAction((action) => {
            actionBroadcaster.enqueue(action.targetWindowType, action);
        });
    }
    if (electronBridge && 'onActionBroadcasterActions' in electronBridge) {
        electronBridge.onActionBroadcasterActions((actions) => {
            for (const action of actions) {
                // @ts-expect-error we get an error about not specificy enough target window type
                // but it works fine and we're refactoring window type out of action broadcaster
                // soon so this isnt worth fixing in the mean time
                actionBroadcaster.enqueue(action.targetWindowType, action);
            }
        });
    }

    if (process.env.APP_NAME === 'first-responder') {
        const cadNextWindowTypes = Object.values(WorkspaceWindowTypeEnum)
            .filter((windowType) => windowType.isCadNext)
            .map((windowType) => windowType.name);
        if (electronBridge && 'actionBroadcasterRegisterWindows' in electronBridge) {
            // @ts-expect-error same as above comment more or less
            electronBridge.actionBroadcasterRegisterWindows([...cadNextWindowTypes, 'ROOT']);
        }
    } else {
        if (!workspaceWindowType) {
            throw new Error('Unexpectedly did not find window type');
        } else if (!isValidWindowType(workspaceWindowType)) {
            throw new Error('Invalid window type');
        }
        if (electronBridge && 'actionBroadcasterInterface' in electronBridge) {
            electronBridge.actionBroadcasterInterface.registerSelf(workspaceWindowType);
        }
        if (electronBridge && 'actionBroadcasterRegisterWindows' in electronBridge) {
            electronBridge.actionBroadcasterRegisterWindows([workspaceWindowType]);
        }
    }
}

export const actionBroadcaster = new ActionBroadcaster<CadNextAction>({
    onAck:
        electronBridge && 'actionBroadcasterInterface' in electronBridge
            ? electronBridge.actionBroadcasterInterface.ack
            : electronBridge && 'actionBroadcasterAck' in electronBridge
            ? electronBridge.actionBroadcasterAck
            : undefined,
    onTimeout: (action) => {
        logWarn('actionbroadcaster timeout', {
            actionType: action.type,
        });
    },
    onError: ({ errorType, action }) => {
        logErrorMessage('actionbroadcaster error', {
            errorType,
            actionType: action.type,
        });
    },
});
